const host = 'https://europe-west2-prj-tca-prd-5103.cloudfunctions.net';

const dashboards = {
  fixedincome: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: '42a54c0e-4904-4412-8765-7c1467c69fc6',
      tradedetails: '501028a7-b7f8-4e72-a0f7-4b86633064b3',
      outliers: `057ed98a-762b-4826-92bf-b3e226dea1f8`,
      pmoverview: '77839140-773f-4c9f-aee5-1039b27d9f05',
      traderoverview: `93ba0ccd-9f8f-4592-8e15-4f140f6eb5b8`,
    },
    worksheetId: 'ec2d198e-c7d2-43fc-8d75-1bfdd885331a',
  },
  fx: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: 'f92493b8-69d6-4ffb-a5a7-f213ae2b2fec',
      tradedetails: 'fb8bf10e-1791-4a10-b7c3-63bc15bede3b',
      outliers: `105d7364-affe-489d-80c8-588537f3f2d2`,
      pmoverview: 'na',
      traderoverview: `na`,
    },
    worksheetId: '00c0a505-180d-463c-ab76-481a8a16ded5',
  },
  fxforward: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `7c97defd-642d-4b5a-86ab-018b5c51e75c`,
      tradedetails: `d3ba5f69-67b9-4d89-8170-46a68bec0141`,
      outliers: `40f905e7-f0ba-4fc6-8739-5536395fb400`,
      pmoverview: `na`,
      traderoverview: `na`,
    },
    worksheetId: '6f0f5efb-a5a8-4ee9-9442-8dc652481120',
  },
  irs: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: '98a1fadf-fe7b-4822-9d4c-b9140b636b6c',
      tradedetails: 'a79cc19d-7dfc-4bab-a6b3-ab38b3b000f8',
      outliers: '59c5a6a6-e2fb-4572-80e4-cf2447a5c919',
      pmoverview: 'na',
      traderoverview: 'na',
    },
    worksheetId: 'bd955c4e-051f-40b0-8d2b-d1dc34c66ac0',
  },
};

const config = {
  uploadsItemsPerPage: 7,
  uploadsPaginationItems: 10,
  uploadsPreviewColumns: 8,
  bepActiveFlag: true,
  repLinearActiveFlag: true,
  fepSpotActiveFlag: true,
  fepForwardsActiveFlag: true,
  fepNonLinearActiveFlag: false,
  endpoints: {
    uploadDetails: `${host}/upload-details`,
    getUploadUrl: `${host}/get-upload-url`,
    uploads: `${host}/uploads`,
    mapUpload: `${host}/map-upload`,
    downloadFile: `${host}/download-file`,
    deleteIngest: `${host}/delete-ingest`,
    cancelIngest: `${host}/cancel-ingest`,
    approveVerificationReport: `${host}/approve-verification-report`,
    requestAccount: `${host}/request-account`,
    getUserData: `${host}/get-user-data`,
    verifyUserToken: `${host}/verify-user-token`,
    getThoughtSpotToken: `${host}/get-thoughtspot-token`,
    getJittoEmbedToken: `${host}/get-jitto-embed-token`,
    preferences: `${host}/user-preferences`,
    getLogUrl: `${host}/get-log-url`,
    mappingAdmin: `${host}/mapping-admin`,
    mappingAdminValues: `${host}/mapping-admin-values`,
    getMappingAuditTrail: `${host}/mapping-audit-trail`,
  },
  uploadValidationPollInterval: 5000,
  oktaAccountManagementLink:
    'https://parameta-accounts.okta.com/enduser/settings?fromLogin=true',
  // Jitto Answer embed (ANS-545): off until UAT signs the Jitto Answer dashboards off. When on, a
  // dashboard with an embedded uuid in config/jittoDashboards.json renders from
  // Jitto Answer and every other one shows a notice; nothing asks ThoughtSpot
  // (no ThoughtSpot embed, AI Assistant, dashboard builder or logout). When off,
  // all of it is ThoughtSpot.
  jittoEmbedActiveFlag: false,
  // The tenant's own Jitto host: @jitto/analyze-embed frames only <this>/embed (ANS-678).
  // Empty until tca-prd has its host: a dashboard then fails cleanly, before any token.
  jittoEmbedOrigin: '',
  // Jitto applies host filters (filters on mount, setFilters): @jitto/analyze-embed 0.3.0 (ANS-801).
  // Only read with the Jitto embed on: before turning that on here, this environment's Jitto must
  // run jitto-analyze#540 with EMBED_HOST_FILTERS on and single_choice listed, and its token
  // function must pass filter_bar on, or every dashboard with Ccy fails.
  jittoHostFilters: true,
  thoughtSpotHost: 'https://parameta.thoughtspot.cloud',
  authProvider: 'okta',
  okta: {
    issuer: 'https://parameta-accounts.okta.com/oauth2/default',
    clientId: '0oa1al7su35dAyGF6417',
    pkce: false,
    tokenManager: {
      storage: 'cookie',
    },
    cookies: {
      sessionCookie: true,
    },
  },
  fxCurrencies: [
    'USD',
    'CAD',
    'CNY',
    'CHF',
    'AUD',
    'JPY',
    'EUR',
    'GBP',
    'NZD',
    'HKD',
    'SEK',
    'SGD',
  ].sort(),
  requestAccountActionURL:
    'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
  requestAccountRetURL:
    'https://tradinganalytics.parametasolutions.com/requestaccount',
  dashboards,
};

export default config;
